import type { ReactNode } from "react";
import { cn } from "../../lib/utils.ts";

export interface SectionHeaderProps {
  /** Small tracked uppercase eyebrow. */
  kicker?: ReactNode;
  title: ReactNode;
  /** Trailing slot (e.g. a "see all" link or live count). */
  right?: ReactNode;
  className?: string;
}

/** Editorial section header: tracked gold kicker over a display title. */
export function SectionHeader({ kicker, title, right, className }: SectionHeaderProps) {
  return (
    <div className={cn("flex items-end justify-between gap-3", className)}>
      <div className="min-w-0">
        {kicker ? <div className="jod-kicker mb-1.5">{kicker}</div> : null}
        <div className="h-display text-[1.25rem] leading-[1.32]">{title}</div>
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}
